import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import { FolderIcon, FolderOpenIcon } from '@heroicons/react/24/outline';
import { TreeIconProps } from './types';

type IconBuilderProps = TreeIconProps & { isOpen?: boolean };

const IconBuilder = ({ icon, isOpen }: IconBuilderProps) => {
  if (!icon)
    return (
      <ConditionalRenderer
        condition={isOpen}
        fallback={<FolderIcon className="h-4 w-4" />}
      >
        <FolderOpenIcon className="h-4 w-4" />
      </ConditionalRenderer>
    );

  if (icon?.custom) return icon.custom;

  const { open, closed } = icon;
  return (
    <ConditionalRenderer condition={isOpen} fallback={closed}>
      {open}
    </ConditionalRenderer>
  );
};

const TreeIcon = (props: TreeIconProps & { isOpen?: boolean }) => (
  <span className="shrink-0">
    <IconBuilder {...props} />
  </span>
);

export default TreeIcon;
